export const loadAssessmentPreviewPage = () =>
  import('src/pages/Assessments/AssessmentPreviewPage').then(
    ({ AssessmentPreviewPage }) => ({ default: AssessmentPreviewPage })
  );

export const loadIndexPage = () =>
  import('src/pages/IndexPage').then(({ IndexPage }) => ({
    default: IndexPage,
  }));
